export default function initTooltip() {
  document.querySelectorAll('.info-tooltip').forEach(tooltip => {
    const title = tooltip.getAttribute('title');
    const tooltipEl = document.createElement('span');

    tooltipEl.textContent = title;
    tooltipEl.classList.add('tooltip');
    tooltip.appendChild(tooltipEl);
    tooltip.removeAttribute('title'); 
  });
}
